define(
({
  "alert": "Hälytys",
  "okay": "Selvä"
})
);
